import { Stack } from "@mui/material";
import { CircularLoading, NoDataWarning } from "../../../components/common";
import { HealthMedicineDetails } from "./HealthMedicineDetails";
import { MedicationMobileList } from "./medications/MedicationMobileList";

interface IProps {
  data: any;
  loading?: boolean;
  setRefetch?: any;
  isRefetching?: boolean;
  prescriptionDocuments?: any[];
  handleOpen?: () => void;
  setBinaryUrl?: (url: string) => void;
  /** Grid de cards no web (ex.: 3 colunas preenchendo a tela). */
  columns?: number;
}

export function ControlPrescriptions({
  data,
  loading,
  setRefetch,
  isRefetching,
  prescriptionDocuments,
  handleOpen,
  setBinaryUrl,
  columns,
}: IProps) {
  const medications = data?.filter(
    (el: any) => el?.type === "medication",
  );
  const otherItems = data?.filter(
    (el: any) => el?.type !== "medication",
  );

  return (
    <Stack width="100%" sx={{ minWidth: 0 }}>
      {data?.length ? (
        <Stack
          width="100%"
          spacing={2}
          sx={{ opacity: isRefetching ? 0.7 : 1, transition: "opacity 0.2s" }}
        >
          {medications?.length > 0 && (
            <MedicationMobileList
              items={medications}
              setRefetch={setRefetch}
              isRefetching={isRefetching}
              prescriptionDocuments={prescriptionDocuments}
              handleOpen={handleOpen}
              setBinaryUrl={setBinaryUrl}
              columns={columns}
            />
          )}

          {otherItems?.map((el: any) => (
            <HealthMedicineDetails
              key={el.date + el.name}
              fullData={el.fullResource}
              type={el.type}
              name={el.name}
              result={el.result}
              date={el.date}
              setRefetch={setRefetch}
            />
          ))}
        </Stack>
      ) : loading ? (
        <Stack
          height="100%"
          alignItems="center"
          justifyContent="center"
          spacing={2}
          p={3}
        >
          <CircularLoading />
        </Stack>
      ) : (
        <Stack width="100%" mt={2}>
          <NoDataWarning />
        </Stack>
      )}
    </Stack>
  );
}
